import { useEffect, useState } from 'react';
import { Alert, Button } from 'react-bootstrap';
import { t } from 'i18next';
import { getAppVersion } from '../../services/settings';
import { APP_VERSION } from '../../config/version';

export function UpdateBanner() {
    const [newVersionAvailable, setNewVersionAvailable] = useState(false);
    const [newVersion, setNewVersion] = useState('');
    const [dismissed, setDismissed] = useState(false);

    useEffect(() => {
        // Verificar versión al montar el componente
        checkVersion();

        // Verificar versión cada 5 minutos
        const interval = setInterval(() => {
            checkVersion();
        }, 5 * 60 * 1000); // 5 minutos

        return () => clearInterval(interval);
    }, []);

    const checkVersion = () => {
        getAppVersion()
            .then((response: any) => {
                if (response.data.status === '1') {
                    const serverVersion = response.data.data.version;

                    // Comparar versiones
                    if (serverVersion !== APP_VERSION) {
                        setNewVersion(serverVersion);
                        setNewVersionAvailable(true);
                        setDismissed(false);
                    }
                }
            })
            .catch((error: any) => {
                console.log('Error checking version:', error);
            });
    };

    const handleReload = () => {
        // Limpiar caché y recargar
        if ('caches' in window) {
            caches.keys().then((names) => {
                names.forEach((name) => {
                    caches.delete(name);
                });
            });
        }
        window.location.reload();
    };

    const handleDismiss = () => {
        setDismissed(true);
    };

    if (!newVersionAvailable || dismissed) {
        return null;
    }

    return (
        <Alert variant="info" className="update-banner mb-0" dismissible={false}>
            <div className="d-flex align-items-center justify-content-between">
                <div className="update-message">
                    <i className="bi bi-info-circle-fill me-2"></i>
                    <strong>{t('New version available!')}</strong>
                    {' '}
                    {t('A new version ({{version}}) of the application is available.', { version: newVersion })}
                    {' '}
                    {t('Please reload to get the latest features and improvements.')}
                </div>
                <div className="update-actions">
                    <Button
                        variant="light"
                        size="sm"
                        onClick={handleDismiss}
                        className="me-2"
                    >
                        {t('Later')}
                    </Button>
                    <Button
                        variant="primary"
                        size="sm"
                        onClick={handleReload}
                    >
                        <i className="bi bi-arrow-clockwise me-1"></i>
                        {t('Reload now')}
                    </Button>
                </div>
            </div>
        </Alert>
    );
}
